import { HStack, useCheckboxGroup } from '@chakra-ui/react';

import { CustomBadgeCheckbox } from 'components/atoms/form/customBadgeCheckbox';
import { CompanyLocationEnum } from 'lib/generated/graphql';
import { useJobFilters } from 'lib/repositories/jobsShowcaseFilters';

import { MobileFilterCard } from '../card';

export interface CompanyLocationProps {
  handleSearchJobs(): void;
}

export const MobileCompanyLocationFilter = ({
  handleSearchJobs,
}: CompanyLocationProps) => {
  const { filters, setCompanyLocation } = useJobFilters();

  const { setValue, getCheckboxProps } = useCheckboxGroup({
    defaultValue: filters.companyLocation || [],
    value: filters.companyLocation,
    onChange: (values: CompanyLocationEnum[]) => {
      setCompanyLocation(values);
    },
  });

  const resetFilter = () => {
    setValue([]);
  };

  return (
    <MobileFilterCard
      isActive={
        filters.companyLocation !== undefined &&
        filters.companyLocation?.length > 0
      }
      showTooltip={false}
      showResetFilter
      resetFilter={resetFilter}
      label='Localização da empresa'
      title='Localização da empresa'
      handleSearchJobs={handleSearchJobs}
    >
      <HStack gap={2}>
        <CustomBadgeCheckbox
          label='Brasil'
          {...getCheckboxProps({ value: CompanyLocationEnum.Brazil })}
        />
        <CustomBadgeCheckbox
          label='Fora do Brasil'
          {...getCheckboxProps({ value: CompanyLocationEnum.Us })}
        />
      </HStack>
    </MobileFilterCard>
  );
};
